import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientInterface, ClientType } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetSignatoriesUseCase implements UseCase<Observable<Transaction<ClientInterface[]>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(): Observable<Transaction<ClientInterface[]>> {
        return this.contractProvider.current().pipe(
            map((transaction) =>
                transaction.map(
                    (contract) => {
                        const signatories: ClientInterface[] = [];

                        contract.holders.map((holder) => {
                            if (holder.type === ClientType.NATURAL_PERSON) {
                                signatories.push(cloneDeep(holder));
                            } else {
                                holder.legalGuardians.map((legalGuardian) => {
                                    if (!signatories.find((it) => it.id.value === legalGuardian.id.value)) {
                                        signatories.push(cloneDeep(legalGuardian));
                                    }
                                });
                            }
                        });

                        return Transaction.success(signatories);
                    },
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
